module.exports = __webpack_public_path__ + "img/not_selected.2badf6a0.png";